// @flow

export { FieldUruguayanDocument } from './field-uruguayan-document';
export { FieldUruguayanPhoneNumber } from './field-uruguayan-phone-number';
